import React, { useContext } from "react";
import { useForm } from "react-hook-form";

import "./Form.css";
import { AuthContext } from "./context/auth-context";
import { useHistory } from "react-router-dom";
import { useHttpClient } from "./hooks/http-hook";
import LoadingSpinner from "./LoadingSpinner/LoadingSpinner";
import Modal from "./Modal";

const Login = () => {
  const auth = useContext(AuthContext);
  const history = useHistory();
  const { register, handleSubmit, errors } = useForm(); // initialise the hook
  const { error, sendRequest, clearError, isLoading } = useHttpClient();

  const confirmLogin = async (userData) => {
    const { email, password } = userData;
    try {
      const responseData = await sendRequest(
        process.env.REACT_APP_LOGIN,
        "POST",
        JSON.stringify({
          email,
          password,
        }),
        {
          "Content-Type": "application/json",
        }
      );
      auth.login();
      history.push("/");
    } catch (err) {}
  };
  const onSubmit = (data) => {
    confirmLogin(data);
  };
  return (
    <React.Fragment>
      {isLoading && (
        <div style={{ width: "100px", margin: "0 auto" }}>
          <LoadingSpinner />
        </div>
      )}
      {error && (
        <Modal error={error || "An error occurred"} onClear={clearError} />
      )}
      <form className="authentication-form" onSubmit={handleSubmit(onSubmit)}>
        <div className="container form-group form-area my-auto mx-auto">
          <div className="form-heading text-center">
            <h3 className="text-info text-uppercase">Login </h3>
          </div>
          <label htmlFor="email" className="font-weight-bold form-label pt-3">
            Email
          </label>
          <input
            type="email"
            className="form-control"
            name="email"
            placeholder="Email"
            ref={register({ required: true })}
          />
          {errors.email && (
            <div className="small text-danger">Email is required</div>
          )}
          <label
            htmlFor="password"
            className="font-weight-bold form-label pt-3"
          >
            Password
          </label>
          <input
            type="password"
            className="form-control"
            placeholder="Password"
            name="password"
            ref={register({ required: true, minLength: 6 })}
          />
          {errors.password && (
            <div className="small text-danger">
              Password must be atleast 6 characters long
            </div>
          )}
          <div className="py-4 text-center">
            <input type="submit" className="btn btn-outline-info" />
          </div>
        </div>
      </form>
    </React.Fragment>
  );
};

export default Login;
